<template>
  <div>
    
    <h1 class="mdn-Heading mdn-Heading--sm">Gerenciamento de Menus</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovoMenu" />

    <SGPTabelaComponent
      v-if="listaDeMenus.length"
      :colunas="colunas"
      :dados="listaDeMenus"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Cadastro de Menu"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioMenuComponent
        :tipoFormulario="tipoFormulario"
        :menu="menu"
      />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="abrirModalDeletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingMenus"/>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import FormularioMenuComponent from '../../components/FormularioMenuComponent.vue';
import deletar from "@/././common/mixins/deletar.js";

export default {
  name: "ListagemMenusComponent",
  mixins: [deletar],
  components: { FormularioMenuComponent },

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      menusSelecionados: [],
      abrirModal: false,
      abrirModalDeletarDados: false,
      tipoFormulario: 'salvar',
      menu: {}
    }
  },
  
  created () {
    this.listarMenus();
  },
  computed: {
    ...mapGetters('menus', ['listaDeMenus', 'loadingMenus']),

    colunas () {
      return [
        {
          key: 'selecionar',
          label: 'Acões',
          sortable: false
        },
        // {
        //   key: 'ordenacao',
        //   label: 'Ordenação',
        //   sortable: false
        // },
        {
          key: 'menu',
          label: 'Nome',
          sortable: false
        },
        {
          key: 'acl_menu.menu',
          label: 'Menu Principal',
          sortable: false
        },
        {
          key: 'route_name',
          label: 'Router Name',
          sortable: false
        },
        {
          key: 'route_link',
          label: 'Router Link',
          sortable: false
        },
      ]
    }
  },

  methods: {
    ...mapActions('menus', ['listarMenus','excluirMenus']),

    gerenciadorDeSelecionados (selecionados) {
      this.menusSelecionados = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.menu = this.menusSelecionados[0];
      this.abrirModal = true;
    },

    confirmarDelecao () {
      this.excluirMenus(this.menusSelecionados);
      this.abrirModalDeletarDados = false;
    },

    adicionarNovoMenu () {
      this.menu = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    }

  }

}
</script>